import React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { I18nextProvider } from "react-i18next"
import store from "../../app/store"
import ChatBox from "./Chatbox/Chatbox"
import AiChatBotPage from "./AiChatBot/AiChatBotPage"
import { RootLayout } from "./Layouts"

const COMPONENTS = {
  ChatBox,
  AiChatBotPage,
}

const mountComponents = () => {
  const nodes = document.querySelectorAll("[data-react-component]:not([data-mounted])")
  if (!nodes.length) return

  const i18n = window.i18n
  if (!i18n) {
    window.addEventListener("i18n:ready", mountComponents, { once: true })
    return
  }

  nodes.forEach((node) => {
    const componentName = node.getAttribute("data-react-component")
    const Component = COMPONENTS[componentName]

    if (!Component) {
      console.error(`❌ Component ${componentName} not found`)
      console.log("Available components:", Object.keys(COMPONENTS))
      return
    }

    node.setAttribute("data-mounted", "true")

    const props = JSON.parse(node.getAttribute("data-props") || "{}")
    if (props.locale) {
      i18n.changeLanguage(props.locale)
    }

    try {
      const root = createRoot(node)
      root.render(
        <Provider store={store}>
          <I18nextProvider i18n={i18n}>
            <RootLayout themeName={props?.themeName ?? "default"}>
              <Component {...props} />
            </RootLayout>
          </I18nextProvider>
        </Provider>
      )
    } catch (error) {
      console.error("❌ Error rendering component:", error)
      console.error("Error stack:", error.stack)
    }
  })
}

document.addEventListener("DOMContentLoaded", mountComponents)
document.addEventListener("turbolinks:load", mountComponents)

console.log("🔵 widgets_entry.js loaded")
